import { FC, ReactNode } from 'react'
import Card from 'components/cards/base/Card'
import classNames from 'classnames'
import { marginHeader, sectionPaddingLarge } from 'project/padding'

type KeyBenefitsSectionType = {
  title?: ReactNode
}
const benefits = [
  {
    benefit:
      'Seamless integration simplifies client product upsell.  Challenger banks integrate our services directly into the client sign up process, removing barriers to purchase.  This creates a new revenue stream that can be directly sold to clients as part of their existing registration process.   Moreover, the cost per acquisition (CPA) can be significantly lower than pay-per-click (PPC) advertising.',
    icon: (
      <svg
        width='42'
        height='44'
        viewBox='0 0 42 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.94737 19.8H5.52632V35.2H9.94737V19.8ZM23.2105 19.8H18.7895V35.2H23.2105V19.8ZM42 39.6H0V44H42V39.6ZM36.4737 19.8H32.0526V35.2H36.4737V19.8ZM21 4.972L32.5168 11H9.48316L21 4.972ZM21 0L0 11V15.4H42V11L21 0Z'
          fill='#1D1D1F'
        />
      </svg>
    ),
    title: 'Banks and Fintech',
    usage: (
      <span>
        By integrating our tools, they can seamlessly offer a virtual office
        address during the customer sign-up process.
      </span>
    ),
  },
  {
    benefit: (
      <span>
        We simplify mail processing for accountancy firms, saving time and
        effort. Our API integration creates a seamless client experience. For
        firms without in-house dev experience, our Partner Portal offers an easy
        solution, offering the same products and services. You can manage
        customer accounts and subscriptions without immediate API integration.{' '}
        <br />
        <br />
        Accountancies can now provide a comprehensive company registration
        service without the added administrative complications and headaches.{' '}
      </span>
    ),
    content:
      'Security and privacy are built into everything we do: At Hoxton Mix, we take the responsibility of processing mail seriously, so you can feel confident that private and confidential information will remain so.',
    icon: (
      <svg
        width='44'
        height='44'
        viewBox='0 0 44 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M39.1111 0H4.88889C2.2 0 0 2.2 0 4.88889V39.1111C0 41.8 2.2 44 4.88889 44H39.1111C41.8 44 44 41.8 44 39.1111V4.88889C44 2.2 41.8 0 39.1111 0ZM39.1111 39.1111H4.88889V4.88889H39.1111V39.1111Z'
          fill='#1D1D1F'
        />
        <path
          d='M20.1667 11.5378H7.94444V15.2044H20.1667V11.5378Z'
          fill='#1D1D1F'
        />
        <path
          d='M36.6667 31.1667H24.4444V34.8333H36.6667V31.1667Z'
          fill='#1D1D1F'
        />
        <path
          d='M36.6667 25.0556H24.4444V28.7222H36.6667V25.0556Z'
          fill='#1D1D1F'
        />
        <path
          d='M12.2222 36.6667H15.8889V31.7778H20.7778V28.1111H15.8889V23.2222H12.2222V28.1111H7.33333V31.7778H12.2222V36.6667Z'
          fill='#1D1D1F'
        />
        <path
          d='M27.1089 19.4333L30.5556 15.9867L34.0022 19.4333L36.5933 16.8422L33.1467 13.3711L36.5933 9.92444L34.0022 7.33333L30.5556 10.78L27.1089 7.33333L24.5178 9.92444L27.9644 13.3711L24.5178 16.8422L27.1089 19.4333Z'
          fill='#1D1D1F'
        />
      </svg>
    ),
    title: 'Accountancy Firms',
    usage:
      'Accountancy firms often provide company formation and registered/director address services. However, managing post can be cumbersome and inefficient as postal volumes increase.  Human error on manual processing creeps in, customer service needs increase and complexity outside of core capabilities becomes a business burden.',
  },
]
const KeyBenefitsSection: FC<KeyBenefitsSectionType> = ({
  title = (
    <>
      <span>Discover how the business </span>
      <br className='d-none d-lg-block' />
      <span>sectors leverage our tools.</span>
    </>
  ),
}) => {
  return (
    <div>
      <div
        className={classNames('text-center', marginHeader, sectionPaddingLarge)}
      >
        <h2 className='fw-semibold fs-fluid-18-34'>
          Who Uses Our Enterprise Solutions?
        </h2>
        <h3 className='fw-semibold fs-fluid-36-80 lh-105 whitespace-nowrap'>
          {title}
        </h3>
      </div>
      <div className='row row-cols-1  flex-md-wrap  row-cols-md-2 g-3 g-md-5 align-items-stretch'>
        {' '}
        {benefits.map(({ benefit, content, icon, title, usage }) => (
          <div>
            <Card padding='xl' shadow className='bg-white'>
              <h4 className='d-flex align-items-start fw-semibold mb-8 gap-2 fs-fluid-24-36'>
                {icon}
                {title}
              </h4>
              <div className='fw-bold fs-fluid-16-20'>
                Usage. <span className='text-muted fw-semibold'>{usage}</span>
              </div>

              <br />

              <div className='fw-bold fs-fluid-16-20'>
                Benefit.{' '}
                <span className='text-muted fw-semibold'>{benefit}</span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  )
}

export default KeyBenefitsSection
